module.exports = __webpack_public_path__ + "static/pet-1162c6f9e1b524ff35602db9d45dc9a1.jpg";